import React from "react";
import Icon from "./Icon";
import { STATUS, statusOf } from "./catalogModel";

const CHIP_ORDER = ["active", "verified", "unverified", "inactive"];

/** Environment-wide summary: "N of M active", a proportion bar, and status chips that double as filters. */
export default function StatStrip({ products, environment, statusFilter, onStatusFilter }) {
  const counts = Object.fromEntries(CHIP_ORDER.map((s) => [s, products.filter((p) => statusOf(p) === s).length]));
  const inCatalog = products.length - counts.inactive;
  const toggle = (s) => onStatusFilter(statusFilter.includes(s) ? statusFilter.filter((x) => x !== s) : [...statusFilter, s]);
  const label = `${counts.active} active, ${counts.verified} verified but inactive, ${counts.unverified} not verified`;

  return (
    <div className="ac-stats">
      <div className="ac-stat-h">{`${counts.active} of ${inCatalog} active in ${environment}`}</div>
      <div className="ac-seg" role="img" aria-label={label}>
        {CHIP_ORDER.map((s) => <i key={s} className={s} style={{ flex: counts[s] }} />)}
      </div>
      <div className="ac-stat-row">
        {CHIP_ORDER.filter((s) => s !== "inactive" || counts.inactive > 0).map((s) => (
          <button key={s} type="button" className={`ac-stat ${s}${statusFilter.includes(s) ? " on" : ""}`}
            aria-pressed={statusFilter.includes(s)} onClick={() => toggle(s)}>
            <Icon n={STATUS[s].icon} s={14} w={2.4} /><b>{counts[s]}</b>{STATUS[s].label}
          </button>
        ))}
      </div>
    </div>
  );
}
